import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

export const Route = createFileRoute('/admin/posts/$slug')({
  params: z.object({ slug: z.string() }),
})
